var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEconomic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49998 4.8105L9.49998 7.8105L13.7802 3.53025L15.5 5.25V0.75H11L12.7197 2.46975L9.49998 5.6895L6.49998 2.6895L0.719727 8.46975L1.78023 9.53025L6.49998 4.8105Z",
    fill: "#059002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomic);
export default __webpack_public_path__ + "static/media/economic.a1423a85265811605685981c32126409.svg";
export { ForwardRef as ReactComponent };